// extracted by mini-css-extract-plugin
module.exports = {"root":"Play-root-2rx0x","down":"Play-down-3WpYz","up":"Play-up-r23N7","face":"Play-face-3m33y"};